import * as fr from "./legal.fr";
import * as en from "./legal.en";
import * as de from "./legal.de";
import * as it from "./legal.it";

const LEGAL = { fr, en, de, it };

// Passer à true quand chaque texte est validé : active la page publique et ses liens (pied de page, paramètres).
export const PRIVACY_PUBLISHED = true;
export const TERMS_PUBLISHED = false;
export const LEGAL_PUBLISHED = PRIVACY_PUBLISHED || TERMS_PUBLISHED;

// Retourne { labels, privacy, terms } pour la langue demandée (repli FR).
export function legalFor(lang) {
  return LEGAL[lang] || LEGAL.fr;
}
